import { Lease, LeaseStatusType } from '../../types/lease'
import { LeaseActionTypes, SET_LEASE_LIST, SET_LEASE_LOADING, SET_LEASE_ERROR, SET_SELECTED_LEASE, SET_SELECTED_STATUS } from './types'

export interface LeaseState {
    leaseList: Lease[] | null
    loading: boolean
    error: string | null
    selectedLease?: Lease | null
    selectedStatus: LeaseStatusType | null
}

const initialState: LeaseState = {
    leaseList: null,
    loading: false,
    error: null,
    selectedLease: null,
    selectedStatus: null,
}

export const leaseReducer = (
    state = initialState,
    action: LeaseActionTypes,
): LeaseState => {
    switch (action.type) {
        case SET_LEASE_LIST:
            return {
                ...state,
                leaseList: action.leaseList,
            }
        case SET_LEASE_LOADING:
            return {
                ...state,
                loading: action.loading,
            }
        case SET_LEASE_ERROR:
            return {
                ...state,
                error: action.error,
            }
        case SET_SELECTED_LEASE:
            return {
                ...state,
                selectedLease: action.selectedLease,
                // When we set a lease, also update its status
                selectedStatus: action.selectedLease?.status ?? null,
            }
        case SET_SELECTED_STATUS:
            return {
                ...state,
                selectedStatus: action.selectedStatus,
            }
        default:
            return state
    }
} 